<ion-card class="config-card">
  <ion-item
    lines="none"
    [button]="canOpen()"
    (click)="canOpen() && showPopOver($event)"
  >
    <div class="status-wrapper" slot="start" [ngClass]="statusClass()">
      <ion-icon name="settings" class="status-icon"></ion-icon>
    </div>

    <ion-label class="ion-text-wrap">
      @if (configuration().installed) {
        <p class="status-label">
          <span class="current-config">{{
            'configuration_current' | translate
          }}</span>
        </p>
      }

      <p class="status-label">
        @if (configuration().pending && !configuration().accepted) {
          <span class="date-stamp">{{
            configuration().added | date: 'mediumDate'
          }}</span>
          • {{ 'configuration_awaiting' | translate }}
        } @else if (!configuration().pending && configuration().accepted) {
          <span class="date-stamp">{{
            configuration().added | date: 'mediumDate'
          }}</span>
          • {{ 'configuration_acceptedAt' | translate }}
          {{ configuration().acceptedAt | date: 'mediumDate' }}
        } @else {
          {{ 'configuration_refused' | translate }}
          <span class="date-stamp date-stamp-plain">{{
            configuration().acceptedAt || configuration().added
              | date: 'mediumDate'
          }}</span>
        }
      </p>

      <h2 class="config-description">{{ configuration().description }}</h2>
    </ion-label>
  </ion-item>
</ion-card>
